import styled from '@emotion/styled'
import { Button } from 'ui-components/Button'

export const Total = styled.div`
  display: grid;
  grid-template-columns: 40% auto 120px;
`

export const Bottom = styled.div`
  display: flex;
  justify-content: space-between;
`

export const AlertButton = styled(Button)`
  margin-left: 20px;

  &:disabled {
    display: none;
  }
`
